// extracted by mini-css-extract-plugin
export default {"addAudioButton":"hTGkIpzdI4AJfv3Xfhvi","content":"qJL7t8B5QmWB3aWiDLpp"};